<ul class="steps">
  @for (step of steps(); track step; let idx = $index; let last = $last) {
    <li
      class="step"
      [class.active]="step.active"
      [class.filled]="idx <= activeStepIndex()"
      [class.disabled]="!step.active && step.disabled"
      (click)="!step.disabled ? stepClicked.emit(idx) : $event.preventDefault()"
    >
      {{ idx + 1 }}
      @if (step.label) {
        <div class="step-label">{{ step.label }}</div>
      }
    </li>
    @if (!last) {
      <div
        class="line"
        [class.disabled]="steps()[idx].disabled || !steps()[idx + 1].active && steps()[idx + 1].disabled"
      ></div>
    }
  }
</ul>
